import { urlDateFormat } from 'common/UrlDate';
import { DateTime } from 'luxon';

interface IArgs {
  deliveryDate: DateTime | undefined;
  availabilityDates: readonly DateTime[];
}

export function isDeliveryDateAvailable({ deliveryDate, availabilityDates }: IArgs): boolean {
  return Boolean(
    deliveryDate &&
      availabilityDates.find((dateTime) => dateTime.toFormat(urlDateFormat) === deliveryDate.toFormat(urlDateFormat))
  );
}
